import React from 'react';
import MenuItemModal from '../../components/MenuItemModal/MenuItemModal';

/**
 * Our Menu entry point for the shared product detail dialog.
 * Keeps `OurMenu.jsx` focused on layout and list behavior.
 */
export function OurMenuProductDetailModal({ item, onClose, openIntent = null }) {
  if (!item) return null;
  return <MenuItemModal item={item} onClose={onClose} openIntent={openIntent} />;
}
